import { LinkProps } from '../../components/HelpPages/atoms/Link';
import { QuickLinksProps } from '../../components/HelpPages/molecules/QuickLinks';
import { OptimizelyQuickLinksBlock } from '../../types/optimizely/blocks/quickLinksBlock';
import { mapToLinkProps } from './mapToLinkProps';

export const mapToQuickLinksProps = (
	optiBlock: OptimizelyQuickLinksBlock,
): QuickLinksProps => {
	let items: LinkProps[] = [];

	// title is mandatory - so if it is missing assume
	// the card is not there
	if (optiBlock.title1.value) {
		items.push(
			mapToLinkProps(
				optiBlock.icon1?.value,
				optiBlock.title1.value,
				optiBlock.link1?.value,
			),
		);
	}
	if (optiBlock.title2.value) {
		items.push(
			mapToLinkProps(
				optiBlock.icon2?.value,
				optiBlock.title2.value,
				optiBlock.link2?.value,
			),
		);
	}
	if (optiBlock.title3.value) {
		items.push(
			mapToLinkProps(
				optiBlock.icon3?.value,
				optiBlock.title3.value,
				optiBlock.link3?.value,
			),
		);
	}
	if (optiBlock.title4.value) {
		items.push(
			mapToLinkProps(
				optiBlock.icon4?.value,
				optiBlock.title4.value,
				optiBlock.link4?.value,
			),
		);
	}
	if (optiBlock.title5.value) {
		items.push(
			mapToLinkProps(
				optiBlock.icon5?.value,
				optiBlock.title5.value,
				optiBlock.link5?.value,
			),
		);
	}
	if (optiBlock.title6.value) {
		items.push(
			mapToLinkProps(
				optiBlock.icon6?.value,
				optiBlock.title6.value,
				optiBlock.link6?.value,
			),
		);
	}

	return {
		items,
		linkColorOptions: {
			fontColor: 'primary',
			backgroundColor: 'primary',
		},
	};
};
